import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { FromNoDDL } from "../../../../../CommonDDL/FromNoDDL"


export const SiteVerification = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()


    return (
        <div className="row p-1 m-1 mt-2 ">

            <div className="col-12 col-lg-12" >
                <div className="row bg-white rounded_eic my-2" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>

                    <div className="col-12">
                        <div className="row mt-3">
                            {/* Site Verification */}
                            <div className="col-12 col-lg-2">
                                <span className="text-dark  py-3 all_heading_fontsize">{t('EncroachmentDashboard.SiteVerification')}</span>

                            </div>
                            <div className="col-12 col-lg-2">
                            <FromNoDDL/>
                            </div>
                            <div className="col-12 col-lg-8 text-end pb-2 mb-2 pt-3 pt-lg-0 ">
                                <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                                    <input type="radio" className="btn-check" name="btnradio6" id="sky10" autocomplete="off" checked />
                                    <label className="btn btn-outline-primary fw-bold" for="sky10">{t('EncroachmentDashboard.Total')}</label>

                                    <input type="radio" className="btn-check" name="btnradio6" id="sky20" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky20">{t('EncroachmentDashboard.ZoneA')}</label>

                                    <input type="radio" className="btn-check" name="btnradio6" id="sky30" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky30 ">{t('EncroachmentDashboard.ZoneB')}</label>

                                    <input type="radio" className="btn-check" name="btnradio6" id="sky40" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky40">{t('EncroachmentDashboard.ZoneC')}</label>

                                    <input type="radio" className="btn-check" name="btnradio6" id="sky50" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky50">{t('EncroachmentDashboard.ZoneD')}</label>

                                    <input type="radio" className="btn-check" name="btnradio6" id="sky60" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky60">{t('EncroachmentDashboard.ZoneE')}</label>

                                    <input type="radio" className="btn-check" name="btnradio6" id="sky70" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky70">{t('EncroachmentDashboard.ZoneF')}</label>

                                    <input type="radio" className="btn-check" name="btnradio6" id="sky80" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky80">{t('EncroachmentDashboard.ZoneG')}</label>

                                    <input type="radio" className="btn-check" name="btnradio6" id="sky90" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky90">{t('EncroachmentDashboard.ZoneH')}</label>
                                </div>
                            </div>



                            {/*Site Verification*/}
                            <div className="col-12 col-md-4 pb-3 cursor-pointer"
                            onClick={() => navigate('/SiteVerificationIllegalGrid')}
                            >
                                <div className="p-4 background_style gray_bg_eic rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                                    <div className="row">
                                        <div className="col-9">
                                            <h6 className=" text-dark">{t('EncroachmentDashboard.SiteVerification')}</h6>
                                            <h2 className="pt-2 fw-bold text-danger">30</h2>
                                        </div>
                                        <div className="col-3 d-flex align-items-center justify-content-center ">
                                            <img src="./assets/img/eic_img/SiteVerification.png" style={{ width: '40px' }} alt="" srcset="" />
                                        </div>
                                    </div>
                                </div>
                            </div>



                            {/*Verified notices*/}
                            <div className="col-12 col-md-4 pb-3 cursor-pointer"
                            onClick={() => navigate('/VerifiedNoticesIllegalGrid')}
                            >
                                <div className="p-4 background_style gray_bg_eic rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                                    <div className="row">
                                        <div className="col-9">
                                            <h6 className=" text-dark">{t('EncroachmentDashboard.Verifiednotices')}</h6>
                                            <h2 className="pt-2 fw-bold text-danger">25</h2>
                                        </div>
                                        <div className="col-3 d-flex align-items-center justify-content-center ">
                                            <img src="./assets/img/eic_img/Verified_Notices.png" style={{ width: '40px' }} alt="" srcset="" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/*legal Site*/}
                            <div className="col-12 col-md-4 pb-3 cursor-pointer"
                            onClick={() => navigate('/LegalSiteGrid')}
                            >
                                <div className="p-4 background_style gray_bg_eic rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                                    <div className="row">
                                        <div className="col-9">
                                            <h6 className=" text-dark">{t('EncroachmentDashboard.legalSite')}</h6>
                                            <h2 className="pt-2 fw-bold text-danger">5</h2>
                                        </div>
                                        <div className="col-3 d-flex align-items-center justify-content-center ">
                                            <img src="./assets/img/eic_img/legal_Site.png" style={{ width: '40px' }} alt="" srcset="" />
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>


                </div>
            </div>

        </div>
    )
}